export abstract class NotificationsKey {
  static BASE = ['notifications'];
  static UNSEEN_NOTIFICATIONS = [...NotificationsKey.BASE, 'unseen'];
}
